import { render, staticRenderFns } from "./Question5.vue?vue&type=template&id=7dcd672e&"
import script from "./Question5.vue?vue&type=script&lang=js&"
export * from "./Question5.vue?vue&type=script&lang=js&"
import style0 from "./Question5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
